import React, { useState } from 'react';
import './footer.scss';

const Footer = () => {
    const [currentYear] = useState(new Date().getFullYear())

    return (
        <footer>
            <div className="container">
                <div className="footer-wrapper">
                    <div className="links">
                        <a
                            href="https://www.carrier.com/carrier/en/worldwide/legal/privacy-notice/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Privacy Notice
                        </a>
                        <a
                            href="https://www.carrier.com/carrier/en/worldwide/legal/terms-of-use/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Terms of Use
                        </a>
                        <a
                            href="https://www.carrier.com/carrier/en/worldwide/contact-us/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Contact Us
                        </a>
                    </div>
                    <div className="details">
                        <a
                            href="https://www.corporate.carrier.com/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            A Carrier Company
                        </a>
                        &nbsp; | &nbsp;
                        <span>
                            &copy; {currentYear}&nbsp;
                            Carrier
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
